import { send } from '@actual-app/core/platform/client/connection';

type Task = 'optimise' | 'answer' | 'invoice' | 'analysis';

/**
 * Asks the AI engine and returns its answer only when it has the fields the
 * caller needs; anything else — an error, a timeout, a half answer — is null.
 */
export async function askAi<T extends Record<string, unknown>>(
  task: Task,
  payload: unknown,
  required: (keyof T & string)[],
): Promise<T | null> {
  const result = await send('mtxbudget-ai', { task, payload });
  if (!('data' in result) || !result.data || typeof result.data !== 'object') {
    return null;
  }
  const data = result.data as Record<string, unknown>;
  return required.every(key => data[key] !== undefined) ? (data as T) : null;
}
